module.exports = __webpack_public_path__ + "img/interstitial.ef7a7e7f.png";